import { render, staticRenderFns } from "./Pivot.vue?vue&type=template&id=37a8db8c&"
import script from "./Pivot.vue?vue&type=script&lang=ts&"
export * from "./Pivot.vue?vue&type=script&lang=ts&"
import style0 from "./Pivot.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports